import React, {useState, useEffect} from "react";

export default function GetProperties(){

  const [Properties, SetProperties] = useState([]);

  useEffect(() => {
    const fetchProperties = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/properties.json');
      const jsonresult = await result.json()
      SetProperties(jsonresult)
    }
    fetchProperties();
  }, [])

  return Properties;
}
